import { put } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, data) => {
    return await put(`/basket/${basketId}`, data);
};
